import { SITE } from "./site";
import { SERVICE_LOCATION_NAMES } from "./locations";
import { STATIC_SERVICE_SEO, buildServiceCatalogSchema } from "./serviceSeo";
import { getLocalBookingFaqs } from "./locationSearchContent";

// Shared by the React SEO component and the build-time metadata generator.
// Service areas describe where we arrange travel; the operator remains based in Satna.
const DOMAIN = SITE.domain.replace(/\/+$/, "");
const FARE_DESCRIPTION = "For vehicles with published rates, outstation hire includes fuel with a 300 km daily minimum. Local hire covers 120 km / 12 hours with fuel extra. GST at 5% and applicable trip charges are additional. The final quote and availability are confirmed for the itinerary.";
const canonical = (route) => {
  const pathname = route.replace(/^\/+|\/+$/g, "");
  return `${DOMAIN}${pathname ? `/${pathname}` : ""}/`;
};

const PROVIDER = {
  "@type": "LocalBusiness",
  "@id": `${canonical("/")}#localbusiness`,
  name: SITE.brand,
  description: FARE_DESCRIPTION,
  telephone: SITE.phonePrimary.tel,
  email: SITE.email,
  address: {
    "@type": "PostalAddress",
    addressLocality: SITE.baseCity,
    addressRegion: SITE.region,
    addressCountry: "IN",
  },
};

export const HOME_SERVICE_SCHEMA = {
  ...buildServiceCatalogSchema({ city: SITE.baseCity, route: "/", description: STATIC_SERVICE_SEO.home.description }),
  "@type": "TaxiService",
  name: SITE.brand,
  description: `${STATIC_SERVICE_SEO.home.description} ${FARE_DESCRIPTION}`,
  areaServed: [...SERVICE_LOCATION_NAMES],
  provider: PROVIDER,
  url: canonical("/"),
};

export const TEMPO_TRAVELLER_SCHEMA = {
  ...buildServiceCatalogSchema({ city: SITE.baseCity, route: "/tempo-traveller", description: STATIC_SERVICE_SEO.tempo.description }),
  serviceType: "Tempo Traveller hire",
  description: `13, 17, 20, 21 and 26 total-seat options include one driver, providing 12, 16, 19, 20 and 25 passenger seats respectively. The 9-seater option has a quotation on request. ${FARE_DESCRIPTION}`,
  areaServed: [...SERVICE_LOCATION_NAMES],
  provider: PROVIDER,
  url: canonical("/tempo-traveller"),
};

const staticServiceSchema = (key, route) => ({
  ...buildServiceCatalogSchema({ city: SITE.baseCity, route, description: STATIC_SERVICE_SEO[key].description }),
  provider: PROVIDER,
  areaServed: [...SERVICE_LOCATION_NAMES],
});

export const SERVICES_SCHEMA = staticServiceSchema("services", "/services");
export const FLEET_SCHEMA = staticServiceSchema("fleet", "/fleet");
export const SERVICE_AREAS_SCHEMA = staticServiceSchema("areas", "/service-areas");

export function buildLocationSchemas(loc) {
  return [
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "@id": canonical(loc.slug) + "#breadcrumbs",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Home", item: canonical("/") },
        { "@type": "ListItem", position: 2, name: "Service Areas", item: canonical("/service-areas") },
        { "@type": "ListItem", position: 3, name: loc.cityLabel || loc.city, item: canonical(loc.slug) },
      ],
    },
    {
      ...buildServiceCatalogSchema({ city: loc.city, route: loc.slug, description: loc.description, location: loc }),
      description: `${loc.description} ${FARE_DESCRIPTION}`,
      provider: PROVIDER,
      areaServed: { "@type": "Place", name: loc.city },
      url: canonical(loc.slug),
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [...loc.faqs, ...getLocalBookingFaqs(loc.city, loc)].map((faq) => ({
        "@type": "Question",
        name: faq.q,
        acceptedAnswer: { "@type": "Answer", text: faq.a },
      })),
    },
  ];
}
